module.exports = __webpack_public_path__ + "img/1493574883.7faaee69.jpg";